import { apiPrefix, get } from './common';
const getBankDetailsByRoutingNumber = (routingNumber) => get(`${apiPrefix}/BankDetails/${routingNumber}`);
export default getBankDetailsByRoutingNumber;
